import React, {useEffect, useMemo} from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Spin } from "antd";
import ListLocation from "../../components/ListLocation";
import { columns, columnsProprietaire } from "./columns";
import { loadLocations } from "../../store/actions/locationAction";
import { loadReglements } from "../../store/actions/reglementAction";
import { loadQuittances } from "../../store/actions/quittanceAction";

const Locations = ({ etat, addPanesRequete }) => {

  const dispatch = useDispatch();

  const { locations, reglements, quittances } = useSelector(
    (state) => ({
      locations: state.locations.data,
      reglements: state.reglements.data,
      quittances: state.quittances.data,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(loadLocations());
    dispatch(loadReglements());
    dispatch(loadQuittances());
  }, [dispatch]);

  // Mémoïsation du filtrage et du tri
  const filteredLocations = useMemo(() => {
    if (!locations) return null;

    return locations
      .filter((item) => item.location_etat === etat)
      .sort((a, b) => b.location_id - a.location_id);
  }, [locations, etat]);

  return (
    <Spin spinning={!locations} size="large" tip="Chargement en cours..." wrapperClassName="view-spin">
      <ListLocation
        listData={filteredLocations}
        reglements={reglements}
        quittances={quittances}
        tableOption={etat === "b" ? columnsProprietaire : columns}
        etat={etat}
        addPanesRequete={addPanesRequete}
        titre={true}
        fillHeight
      />
    </Spin>
  );
};

export default Locations;